module.exports = __webpack_public_path__ + "img/03—01—02—Combined—WLAN steering > Disabled Overlay.7c9110d4.jpg";